module.exports = __webpack_public_path__ + "ai.417419b9.svg";